import { zustandStore } from "./zustand.helpers";

const SITE_VISITS_KEY = "csatFeedbackStore-numberOfSiteVisit";

export interface CsatFeedbackState {
    /**
     * A boolean representing if a user has performed any action that would signify that we should
     * ask them for feedback this session
     */
    hasUserPerformedActionWorthFeedback: boolean;

    /**
     * A counter that tracks how many times this user has opened IHub since implementations
     * so we can make sure we aren't displaying CSAT on a user's first page load
     */
    numberOfSiteVisits: number;
}

export interface CsatFeedbackActions {
    /**
     * Helper method to mark that the user has performed an action that is worth prompting for feedback or not
     */
    setHasUserPerformedActionWorthFeedback: (isEligible: boolean) => void;

    /**
     * A helper method to increase the number of visits to IHub recorded for this user.
     * Should only be called once per page load
     */
    incrementNumberOfSiteVisits: () => void;
}

export const initialState: CsatFeedbackState = {
    hasUserPerformedActionWorthFeedback: false,
    numberOfSiteVisits: Number(localStorage.getItem(SITE_VISITS_KEY)) || 0,
};

export const { store: csatFeedbackStore } = zustandStore<
    CsatFeedbackState,
    CsatFeedbackActions
>(
    "CSAT Feedback",
    initialState,

    (set, get) => ({
        setHasUserPerformedActionWorthFeedback: (isEligible: boolean) =>
            set(() => ({
                hasUserPerformedActionWorthFeedback: isEligible,
            })),

        incrementNumberOfSiteVisits: () => {
            localStorage.setItem(
                SITE_VISITS_KEY,
                `${get().numberOfSiteVisits + 1}`,
            );
            set((state) => ({
                numberOfSiteVisits: state.numberOfSiteVisits + 1,
            }));
        },
    }),
);
